














import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PaginationNavigationButton extends Vue {
  @Prop({ required: true }) public isVisible: boolean;
  @Prop({ required: true }) public type: string;

  private emitClick() {
    this.$emit("click");
  }
}
